import React from "react"

import Layout from "../components/layout"
import ProductsMainArea from "../components/ProductsMainArea"
import CmsProductsBridge from "../components/CmsProductsBridge"
import { graphql } from "gatsby"
import Arrow from "../components/Arrow"
import useWebsiteCmsContent from "../hooks/useWebsiteCmsContent"
import { localizedBlockData } from "../services/websiteCms"

const Products = ({
  data: {
    markdownRemark: {
      frontmatter: { title, description, lang, bannerPath },
    },
  },
}) => {
  const payload = useWebsiteCmsContent()
  const cmsPage = localizedBlockData(payload, "products-page", lang) || {}
  const activeTitle = cmsPage.title || title
  const activeDescription = cmsPage.description || description

  return (
    <Layout title={activeTitle} lang={lang}>
      <ProductsMainArea
        title={activeTitle}
        description={activeDescription}
        bannerPath={bannerPath}
      />

      <div className="b-homepage-content">
        <div className="b-layer-main">
          <Arrow />
          <CmsProductsBridge lang={lang} />
        </div>
      </div>
    </Layout>
  )
}

export default Products

// Product cards are API-only. This query is only for the Products page shell.
export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        lang
        description
        bannerPath
      }
    }
  }
`
